export default __webpack_public_path__ + "static/media/brand.f065d747.png";